export default [

     {
          path: '/technology',
          name: 'Technology',
          component: () => import("@/views/Page/Technology/Technology.vue"),
           meta: {
               title: 'Technology',
          },
     }
];